import React from 'react';
import Footer from './Footer';

const ASCII_JESUS = `
            I N R I
               |
  +------------+------------+
               |
             ( + )
            --oOo--
           /   |   \\
          /    |    \\
         /     |     \\
        /      |      \\
               |
              / \\
             /   \\
`;

const NotFound = () => (
  <div className="stt-page">
    <div className="stt-content" style={{ paddingTop: '60px', paddingBottom: '60px', textAlign: 'center' }}>
      <pre className="stt-404-ascii">{ASCII_JESUS}</pre>
      <h1 style={{ fontFamily: 'var(--font-header)', fontSize: '4rem', color: 'var(--navy)', margin: '8px 0 12px', letterSpacing: '0.04em' }}>
        404
      </h1>
      <p style={{ fontSize: '1.1rem', color: 'var(--color-secondary)', marginBottom: '8px' }}>
        Looks like you wandered off the path — don't worry, you're in good hands.
      </p>
      <p className="stt-404-verse">
        "For the Son of Man has come to seek and to save what was lost."
        <br />
        <span>— Luke 19:10</span>
      </p>
      <a href="/" className="btn stt-btn-primary" style={{ marginTop: '32px', display: 'inline-block' }}>
        Return Home
      </a>
    </div>
    <Footer />
  </div>
);

export default NotFound;
